module.exports = __webpack_public_path__ + "img/2e80265c8eb7e@3x.84e84970.png";